const contestSubmissionFormSelector = '.js-contest-submission-form',
  submissionProcessingModalID = '#contest-submission-processing-modal',
  submissionSuccessModalID = '#contest-submission-success-modal',
  urlParams = new URLSearchParams(window.location.search),
  openSuccessModal = urlParams.get('contestSubmissionSuccess') === '1',
  openFailureModal = urlParams.get('contestSubmissionSuccess') === '0';

const contestSubmissionModals = async () => {
  const contestSubmissionForm = document.querySelector(
    contestSubmissionFormSelector
  );
  if (contestSubmissionForm)
    contestSubmissionForm.addEventListener('submit', showProcessingModal);

  if (openSuccessModal)
    setTimeout(() => {
      MicroModal.show(submissionSuccessModalID);
    }, 500);

  // currently not implemented
  if (openFailureModal && false)
    setTimeout(() => {
      MicroModal.show(submissionFailureModalID);
    }, 500);
};

const showProcessingModal = _event => {
  MicroModal.show(submissionProcessingModalID);
};

export default {
  init: contestSubmissionModals,
};
